<div class="datepicker" [class.datepicker--open]="showPicker">
  <div
    class="datepicker__nav-row"
    [class.datepicker__nav-row--grouped]="withNavigation"
    [class.datepicker__nav-row--open]="showPicker"
  >
    <button
      *ngIf="withNavigation"
      type="button"
      class="datepicker__step-btn"
      [attr.title]="prevTitle"
      [attr.aria-label]="prevTitle"
      [disabled]="disabled || isPeriodo || !singleValueExists || !canStepBackward"
      (click)="prev(); $event.stopPropagation()"
    >
      <i class="fas fa-chevron-left"></i>
    </button>

    <div
      class="datepicker__container"
      [class.datepicker__container--disabled]="disabled"
      [class.datepicker__container--open]="showPicker"
      (click)="openPicker()"
    >
      <i class="far fa-calendar-alt datepicker__icon"></i>
      <span
        class="datepicker__text"
        [class.datepicker__text--placeholder]="!inputText"
      >
        <ng-container *ngIf="inputText; else noPlaceholder">
          {{ inputText }}
        </ng-container>
        <ng-template #noPlaceholder>{{ emptyText }}</ng-template>
      </span>
      <button
        *ngIf="inputText && !disabled"
        class="datepicker__clear"
        type="button"
        (click)="clear(); $event.stopPropagation()"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>

    <button
      *ngIf="withNavigation"
      type="button"
      class="datepicker__step-btn"
      [attr.title]="nextTitle"
      [attr.aria-label]="nextTitle"
      [disabled]="disabled || isPeriodo || !singleValueExists || !canStepForward"
      (click)="next(); $event.stopPropagation()"
    >
      <i class="fas fa-chevron-right"></i>
    </button>
  </div>

  <div
    class="datepicker__panel"
    [class.datepicker__panel--periodo]="isPeriodo"
    [class.datepicker__panel--right]="panelAlignRight"
    [ngStyle]="panelStyle"
    *ngIf="showPicker"
  >
    <div class="datepicker__tabs" *ngIf="periodicidades.length > 1">
      <button
        *ngFor="let p of periodicidades"
        type="button"
        class="datepicker__tab"
        [class.datepicker__tab--active]="periodicidade === p.id"
        (click)="selectPeriodicidade(p)"
      >
        {{ p.nome }}
      </button>
    </div>

    <ng-container *ngIf="isDiaria">
      <bs-datepicker-inline
        [(bsValue)]="bsDateValue"
        [bsConfig]="bsConfig"
        [datesDisabled]="disableDates"
        [dateTooltipTexts]="dateTooltipTexts"
        (bsValueChange)="onDaySelected($event)"
      >
      </bs-datepicker-inline>
      <div class="datepicker__today-footer">
        <button type="button" class="datepicker__today-btn" (click)="selectToday()">
          Hoje
        </button>
      </div>
    </ng-container>

    <div class="datepicker__picker" *ngIf="isMensal">
      <div class="datepicker__year-nav">
        <button type="button" class="datepicker__nav-btn" (click)="prevYear()">
          <span class="fas fa-chevron-left"></span>
        </button>
        <span class="datepicker__nav-label">{{ currentYear }}</span>
        <button type="button" class="datepicker__nav-btn" (click)="nextYear()">
          <span class="fas fa-chevron-right"></span>
        </button>
      </div>
      <div class="datepicker__grid datepicker__grid--cols-3">
        <button
          *ngFor="let m of months"
          type="button"
          class="datepicker__option"
          [class.datepicker__option--selected]="isSelectedMonth(m.id)"
          [disabled]="isDisabledMonth(m.id)"
          (click)="onMonthSelected(m.id)"
        >
          {{ m.label }}
        </button>
      </div>
    </div>

    <div
      class="datepicker__picker datepicker__picker--scrollable"
      *ngIf="isTrimestral"
    >
      <div *ngFor="let year of yearsRange; trackBy: trackByYear" class="datepicker__group">
        <div class="datepicker__group-label">{{ year }}</div>
        <div class="datepicker__grid datepicker__grid--cols-4">
          <button
            *ngFor="let q of quarters"
            type="button"
            class="datepicker__option"
            [class.datepicker__option--selected]="isSelectedQuarter(q, year)"
            [disabled]="isDisabledQuarter(q, year)"
            (click)="onQuarterSelected(q, year)"
          >
            T{{ q }}
          </button>
        </div>
      </div>
    </div>

    <div
      class="datepicker__picker datepicker__picker--scrollable"
      *ngIf="isSemestral"
    >
      <div *ngFor="let year of yearsRange; trackBy: trackByYear" class="datepicker__group">
        <div class="datepicker__group-label">{{ year }}</div>
        <div class="datepicker__grid datepicker__grid--cols-2">
          <button
            *ngFor="let s of semesters"
            type="button"
            class="datepicker__option"
            [class.datepicker__option--selected]="isSelectedSemester(s, year)"
            [disabled]="isDisabledSemester(s, year)"
            (click)="onSemesterSelected(s, year)"
          >
            S{{ s }}
          </button>
        </div>
      </div>
    </div>

    <div class="datepicker__picker" *ngIf="isAnual">
      <div class="datepicker__year-nav">
        <button
          type="button"
          class="datepicker__nav-btn"
          (click)="prevYearsPage()"
        >
          <i class="fas fa-chevron-left"></i>
        </button>
        <span class="datepicker__nav-label">
          {{ yearsRange[0] }}
          -
          {{ yearsRange[yearsRange.length - 1] }}
        </span>
        <button
          type="button"
          class="datepicker__nav-btn"
          (click)="nextYearsPage()"
        >
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
      <div class="datepicker__grid datepicker__grid--cols-4 datepicker__grid--years">
        <button
          *ngFor="let year of yearsRange; trackBy: trackByYear"
          type="button"
          class="datepicker__option datepicker__option--plain"
          [class.datepicker__option--selected]="isSelectedYear(year)"
          [disabled]="isDisabledYear(year)"
          (click)="onYearSelected(year)"
        >
          {{ year }}
        </button>
      </div>
    </div>

    <bs-daterangepicker-inline
      *ngIf="isPeriodo"
      [(bsValue)]="bsDateRangeValue"
      [bsConfig]="bsConfig"
      (bsValueChange)="onPeriodSelected($event)"
    ></bs-daterangepicker-inline>
  </div>
</div>
